import React, { useEffect } from 'react';
import { Box, useDisclosure } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import Automations from 'pages/Automations';
import useClinicUser from 'shared/hooks/useClinicUser';
import GlobalAutomationsModal from './GlobalAutomationsModal';

const GlobalAutomations = (): JSX.Element => {
  const { isOttoGlobalAdmin } = useClinicUser();
  const { isOpen, onClose, onOpen } = useDisclosure();

  useEffect(() => {
    onOpen();
  }, [onOpen]);

  return isOttoGlobalAdmin ? (
    <>
      <GlobalAutomationsModal isOpen={isOpen} onClose={onClose} />
      <Automations isGlobalEditor={true} />
    </>
  ) : (
    <Box m={6}>
      <Text>Sorry, you do not have access to this page. Please contact support@otto.vet</Text>
    </Box>
  );
};

export default GlobalAutomations;
